import { importAll } from "../helpers";

const examples = [
  {
    name: "1",
    page: 245,
    top: 202,
    bottom: 530,
    youtubeLink: "https://youtube.com/embed/h6kUgp2amto?start=889&autoplay=1",
  },
  {
    name: "2",
    page: 245,
    top: 538,
    bottom: 872,
    youtubeLink: "https://youtube.com/embed/PnCEVy-d9_w?start=9&autoplay=1",
  },
  {
    name: "3",
    page: 245,
    top: 897,
    bottom: 1069,
    youtubeLink: "https://youtube.com/embed/h6kUgp2amto?start=397&autoplay=1",
  },
  {
    page: "245",
    top: 1112,
    bottom: 1362,
    name: "4",
    youtubeLink: "https://youtube.com/embed/bX_IjA3x_rw?start=1144&autoplay=1",
  },
  {
    page: "245",
    top: 1365,
    bottom: 1614,
    name: "5",
    youtubeLink: "https://youtube.com/embed/dIsrQnQdnBU?start=1029&autoplay=1",
  },
  { page: "245", top: 1617, bottom: 1801, name: "6", youtubeLink: "LINK" },
  {
    page: "245",
    top: 1847,
    bottom: 2055,
    name: "7",
    youtubeLink: "https://youtube.com/embed/voiVcgdxHF8?start=0&autoplay=1",
  },
  { page: "246", top: 203, bottom: 518, name: "8", youtubeLink: "LINK" },
  {
    page: "246",
    top: 533,
    bottom: 737,
    name: "9",
    youtubeLink: "https://youtube.com/embed/p2uXhFeSlIg?start=808&autoplay=1",
  },
  {
    page: "246",
    top: 746,
    bottom: 958,
    name: "10",
    youtubeLink: "https://youtube.com/embed/K-Toa_kW3g0?start=0&autoplay=1",
  },
  {
    page: "246",
    top: 917,
    bottom: 1065,
    name: "11",
    youtubeLink: "https://youtube.com/embed/wtbIT8ALNEA?start=709&autoplay=1",
  },
  {
    page: "246",
    top: 1083,
    bottom: 1421,
    name: "12",
    youtubeLink: "https://youtube.com/embed/qEdQKpt5l_0?start=0&autoplay=1",
  },
  {
    page: "246",
    top: 1435,
    bottom: 1601,
    name: "13",
    youtubeLink: "https://youtube.com/embed/wtbIT8ALNEA?start=1023&autoplay=1",
  },
  {
    page: "246",
    top: 1619,
    bottom: 1812,
    name: "14",
    youtubeLink: "https://youtube.com/embed/3NGHqB4BleU?start=18&autoplay=1",
  },
  {
    page: "246",
    top: 1843.5,
    bottom: 2035.5,
    name: "15",
    youtubeLink: "https://youtube.com/embed/u5hRL0zQFUM?start=913&autoplay=1",
  },
  {
    page: "247",
    top: 199,
    bottom: 457,
    name: "16",
    youtubeLink: "https://youtube.com/embed/hW6YZ_AZX80?start=748&autoplay=1",
  },
  {
    page: "247",
    top: 449,
    bottom: 621,
    name: "17",
    youtubeLink: "https://youtube.com/embed/gAmw8ATln68?start=1492&autoplay=1",
  },
  {
    page: "247",
    top: 626,
    bottom: 838,
    name: "18",
    youtubeLink: "https://youtube.com/embed/Nrr7UOnJMqo?start=7&autoplay=1",
  },
  {
    page: "247",
    top: 836,
    bottom: 1047,
    name: "19",
    youtubeLink: "https://youtube.com/embed/NN0ZKZ274t4?start=525&autoplay=1",
  },
  {
    page: "247",
    top: 1036,
    bottom: 1223,
    name: "20",
    youtubeLink: "https://youtube.com/embed/kCRF0jJPijE?start=104&autoplay=1",
  },
  {
    page: "247",
    top: 1208,
    bottom: 1519,
    name: "21",
    youtubeLink: "https://youtube.com/embed/vrQzel186gc?start=60&autoplay=1",
  },
  {
    page: "247",
    top: 1524,
    bottom: 1718,
    name: "22",
    youtubeLink: "https://youtube.com/embed/5Ekfl_RAnA0?start=1255&autoplay=1",
  },
  {
    page: "247",
    top: 1709,
    bottom: 1903,
    name: "23",
    youtubeLink: "https://youtube.com/embed/cYvjr86_aJY?start=311&autoplay=1",
  },
  {
    page: "247",
    top: 1906,
    bottom: 2072,
    name: "24",
    youtubeLink: "https://youtube.com/embed/Q1cZPsqZlaI?start=1994&autoplay=1",
  },
  {
    page: "248",
    top: 196,
    bottom: 369,
    name: "25",
    youtubeLink: "https://youtube.com/embed/3STKpu_FS9g?start=6&autoplay=1",
  },
  {
    page: "248",
    top: 400,
    bottom: 567,
    name: "26",
    youtubeLink: "https://youtube.com/embed/LYD9gyJJwEU?start=312&autoplay=1",
  },
  {
    page: "248",
    top: 586,
    bottom: 790,
    name: "27",
    youtubeLink: "https://youtube.com/embed/C10-45oHfvc?start=955&autoplay=1",
  },
  {
    page: "248",
    top: 801,
    bottom: 1134,
    name: "28",
    youtubeLink: "https://youtube.com/embed/dIsrQnQdnBU?start=1173&autoplay=1",
  },
  {
    page: "248",
    top: 1161,
    bottom: 1497,
    name: "29",
    youtubeLink: "https://youtube.com/embed/Zr-n7tZN7W4?start=1444&autoplay=1",
  },
  {
    page: "248",
    top: 1506,
    bottom: 1858,
    name: "30",
    youtubeLink: "https://youtube.com/embed/jJJrD19AMhg?start=864&autoplay=1",
  },
  {
    page: "248",
    top: 1879,
    bottom: 2091,
    name: "31",
    youtubeLink: "https://youtube.com/embed/-uiR7ODpcv0?start=6&autoplay=1",
  },
  {
    page: "249",
    top: 195,
    bottom: 503,
    name: "32",
    youtubeLink: "https://youtube.com/embed/w9mRMmKRAeI?start=729&autoplay=1",
  },
  {
    page: "249",
    top: 524,
    bottom: 728,
    name: "33",
    youtubeLink: "https://youtube.com/embed/SZ5Jw6KNP3M?start=0&autoplay=1",
  },
  {
    page: "249",
    top: 725,
    bottom: 1159,
    name: "34",
    youtubeLink: "https://youtube.com/embed/DLDbxZ0BJWw?start=578&autoplay=1",
  },
  {
    page: "249",
    top: 1173,
    bottom: 1347,
    name: "35",
    youtubeLink: "https://youtube.com/embed/56iIqFAy7wA?start=1796&autoplay=1",
  },
  {
    page: "249",
    top: 1370,
    bottom: 1752,
    name: "36",
    youtubeLink: "https://youtube.com/embed/RqKWqmsHQ4U?start=149&autoplay=1",
  },
  {
    page: "249",
    top: 1769,
    bottom: 2072,
    name: "37",
    youtubeLink: "https://youtube.com/embed/1W6GQ5tEAxk?start=838&autoplay=1",
  },
  {
    page: "250",
    top: 204,
    bottom: 544,
    name: "38",
    youtubeLink: "https://youtube.com/embed/uLSRSilSzhY?start=973&autoplay=1",
  },
  {
    page: "250",
    top: 560,
    bottom: 902,
    name: "39",
    youtubeLink: "https://youtube.com/embed/fYiw37hpZtY?start=2091&autoplay=1",
  },
  {
    page: "250",
    top: 927,
    bottom: 1291,
    name: "40",
    youtubeLink: "https://youtube.com/embed/bRjKo0QEIuI?start=1364&autoplay=1",
  },
  { page: "250", top: 1309, bottom: 1509, name: "41", youtubeLink: "LINK" },
  {
    page: "250",
    top: 1533,
    bottom: 1868,
    name: "42",
    youtubeLink: "https://youtube.com/embed/_-ItxtsLnic?start=17&autoplay=1",
  },
  { page: "250", top: 1874, bottom: 2112, name: "43", youtubeLink: "LINK" },
  {
    page: "251",
    top: 198,
    bottom: 517,
    name: "44",
    youtubeLink: "https://youtube.com/embed/LYD9gyJJwEU?start=1390&autoplay=1",
  },
  { page: "251", top: 517, bottom: 714, name: "45", youtubeLink: "LINK" },
  {
    page: "251",
    top: 712,
    bottom: 1028,
    name: "46",
    youtubeLink: "https://youtube.com/embed/i5gMQH7pJbg?start=652&autoplay=1",
  },
  { page: "251", top: 1032, bottom: 1252, name: "47", youtubeLink: "LINK" },
  {
    page: "251",
    top: 1251,
    bottom: 1576,
    name: "48",
    youtubeLink: "https://youtube.com/embed/uYB8b1sqXi0?start=520&autoplay=1",
  },
  { page: "251", top: 1571, bottom: 1794, name: "49", youtubeLink: "LINK" },
  {
    page: "251",
    top: 1805,
    bottom: 2051,
    name: "50",
    youtubeLink: "https://youtube.com/embed/6wiQE4LS9No?start=392&autoplay=1",
  },
  {
    page: "252",
    top: 206,
    bottom: 407,
    name: "51",
    youtubeLink: "https://youtube.com/embed/NkoEkyFPaX0?start=805&autoplay=1",
  },
  {
    page: "252",
    top: 403,
    bottom: 607,
    name: "52",
    youtubeLink: "https://youtube.com/embed/YHSCpmnnLpA?start=8&autoplay=1",
  },
  {
    page: "252",
    top: 622,
    bottom: 998,
    name: "53",
    youtubeLink: "https://youtube.com/embed/Dhx9oEa57jo?start=0&autoplay=1",
  },
  {
    page: "252",
    top: 1013,
    bottom: 1183,
    name: "54",
    youtubeLink: "https://youtube.com/embed/yYnFq9zExHE?start=122&autoplay=1",
  },
  {
    page: "252",
    top: 1205,
    bottom: 1399,
    name: "55",
    youtubeLink: "https://youtube.com/embed/u6kFAxfaFko?start=1075&autoplay=1",
  },
  {
    page: "252",
    top: 1413,
    bottom: 1595,
    name: "56",
    youtubeLink: "https://youtube.com/embed/AigWufMZcgs?start=258&autoplay=1",
  },
  {
    page: "252",
    top: 1605,
    bottom: 1927,
    name: "57",
    youtubeLink: "https://youtube.com/embed/m42FQho6PWo?start=610&autoplay=1",
  },
  {
    page: "252",
    top: 1935,
    bottom: 2091,
    name: "58",
    youtubeLink: "https://youtube.com/embed/JjwK4ilaAh8?start=1118&autoplay=1",
  },
  {
    page: "253",
    top: 193,
    bottom: 535,
    name: "59",
    youtubeLink: "https://youtube.com/embed/A3bAiTtM2Pc?start=6&autoplay=1",
  },
  {
    page: "253",
    top: 514,
    bottom: 729,
    name: "60",
    youtubeLink: "https://youtube.com/embed/XQ-oZvbdwxA?start=5&autoplay=1",
  },
  {
    page: "253",
    top: 722,
    bottom: 896,
    name: "61",
    youtubeLink: "https://youtube.com/embed/i9aVgqsiUAU?start=243&autoplay=1",
  },
  {
    page: "253",
    top: 917,
    bottom: 1136,
    name: "62",
    youtubeLink: "https://youtube.com/embed/xLFhH0XIJkc?start=6&autoplay=1",
  },
  {
    page: "253",
    top: 1120,
    bottom: 1293,
    name: "63",
    youtubeLink: "https://youtube.com/embed/i9aVgqsiUAU?start=6&autoplay=1",
  },
  {
    page: "253",
    top: 1306,
    bottom: 1689,
    name: "64",
    youtubeLink: "https://youtube.com/embed/LYD9gyJJwEU?start=768&autoplay=1",
  },
  { page: "253", top: 1694, bottom: 2104, name: "65", youtubeLink: "LINK" },
  {
    page: "254",
    top: 199,
    bottom: 506,
    name: "66",
    youtubeLink: "https://youtube.com/embed/GX_G9R1j19U?start=5&autoplay=1",
  },
  {
    page: "254",
    top: 522,
    bottom: 842,
    name: "67",
    youtubeLink: "https://youtube.com/embed/kcfDxgfHs64?start=1479&autoplay=1",
  },
  { page: "254", top: 855, bottom: 1265, name: "68", youtubeLink: "LINK" },
  { page: "254", top: 1284, bottom: 1484, name: "69", youtubeLink: "LINK" },
  {
    page: "254",
    top: 1484,
    bottom: 1681,
    name: "70",
    youtubeLink: "https://youtube.com/embed/GVl9txM-baE?start=2726&autoplay=1",
  },
  { page: "254", top: 1690, bottom: 1879, name: "71", youtubeLink: "LINK" },
  { page: "254", top: 1897, bottom: 2064, name: "72", youtubeLink: "LINK" },
  {
    page: "255",
    top: 184,
    bottom: 504,
    name: "73",
    youtubeLink: "https://youtube.com/embed/Wk-z4k0a0YE?start=59&autoplay=1",
  },
  {
    page: "255",
    top: 521,
    bottom: 822,
    name: "74",
    youtubeLink: "https://youtube.com/embed/aojgXEZ86xI?start=344&autoplay=1",
  },
  {
    page: "255",
    top: 839,
    bottom: 1153,
    name: "75",
    youtubeLink: "https://youtube.com/embed/dTbesxdLwo8?start=808&autoplay=1",
  },
  {
    page: "255",
    top: 1164,
    bottom: 1351,
    name: "76",
    youtubeLink: "https://youtube.com/embed/dl652_ewMPo?start=950&autoplay=1",
  },
  {
    page: "255",
    top: 1369,
    bottom: 1728,
    name: "77",
    youtubeLink: "https://youtube.com/embed/cnnSeChY--M?start=0&autoplay=1",
  },
  {
    page: "255",
    top: 1737,
    bottom: 2074,
    name: "78",
    youtubeLink: "https://youtube.com/embed/bkNWCx-2AbU?start=1867&autoplay=1",
  },
  { page: 256, top: 194, bottom: 395, name: "79", youtubeLink: "LINK" },
  { page: 256, top: 377, bottom: 560, name: "80", youtubeLink: "LINK" },
  { page: 256, top: 566, bottom: 816, name: "81", youtubeLink: "LINK" },
  { page: 256, top: 840, bottom: 1094, name: "82", youtubeLink: "LINK" },
  { page: 256, top: 1108, bottom: 1295, name: "83", youtubeLink: "LINK" },
  { page: 256, top: 1302, bottom: 1561, name: "84", youtubeLink: "LINK" },
  { page: 256, top: 1587.5, bottom: 1836.5, name: "85", youtubeLink: "LINK" },
  { page: 256, top: 1819.5, bottom: 2078.5, name: "86", youtubeLink: "LINK" },
  { page: 257, top: 188, bottom: 516, name: "87", youtubeLink: "LINK" },
  { page: 257, top: 519, bottom: 884, name: "88", youtubeLink: "LINK" },
  { page: 257, top: 875, bottom: 1443, name: "89", youtubeLink: "LINK" },
  {
    page: 257,
    top: 1449,
    bottom: 1782,
    name: "90",
    youtubeLink: "https://youtube.com/embed/h589-adlGig?start=358&autoplay=1",
  },
  { page: 257, top: 1781.5, bottom: 2104.5, name: "91", youtubeLink: "LINK" },
  { page: 258, top: 195, bottom: 508, name: "92", youtubeLink: "LINK" },
  { page: 258, top: 511, bottom: 832, name: "93", youtubeLink: "LINK" },
  { page: 258, top: 828, bottom: 1754, name: "94", youtubeLink: "LINK" },
  { page: 258, top: 1750.5, bottom: 2105.5, name: "95", youtubeLink: "LINK" },
  { page: 259, top: 194, bottom: 582, name: "96", youtubeLink: "LINK" },
  { page: 259, top: 600, bottom: 961, name: "97", youtubeLink: "LINK" },
  { page: 259, top: 966, bottom: 1352, name: "98", youtubeLink: "LINK" },
  { page: 259, top: 1351, bottom: 2120.5, name: "99", youtubeLink: "LINK" },
  { page: 260, top: 201, bottom: 703, name: "100", youtubeLink: "LINK" },
  { page: 260, top: 716, bottom: 993, name: "101", youtubeLink: "LINK" },
  { page: 260, top: 1002, bottom: 1201, name: "102", youtubeLink: "LINK" },
  { page: 260, top: 1209, bottom: 1456, name: "103", youtubeLink: "LINK" },
  { page: 260, top: 1467, bottom: 1735, name: "104", youtubeLink: "LINK" },
  { page: 260, top: 1734.5, bottom: 2139.5, name: "105", youtubeLink: "LINK" },
  { page: 261, top: 195, bottom: 627, name: "106", youtubeLink: "LINK" },
  { page: 261, top: 641, bottom: 1537, name: "107", youtubeLink: "LINK" },
  { page: 261, top: 1536, bottom: 2082.5, name: "108", youtubeLink: "LINK" },
  { page: 262, top: 194, bottom: 560, name: "109", youtubeLink: "LINK" },
  { page: 262, top: 568, bottom: 1645, name: "110", youtubeLink: "LINK" },
  { page: 262, top: 1649, bottom: 2112.5, name: "111", youtubeLink: "LINK" },
  { page: 263, top: 190, bottom: 622, name: "112", youtubeLink: "LINK" },
  { page: 263, top: 630, bottom: 1401, name: "113", youtubeLink: "LINK" },
  { page: 263, top: 1400, bottom: 2096.5, name: "114", youtubeLink: "LINK" },
  { page: 264, top: 390, bottom: 1800, name: "115", youtubeLink: "LINK" },
  { page: 264, top: 1818.5, bottom: 2075.5, name: "116", youtubeLink: "LINK" },
  { page: 265, top: 191, bottom: 1001, name: "117", youtubeLink: "LINK" },
  { page: 265, top: 1008, bottom: 1262, name: "118", youtubeLink: "LINK" },
  { page: 265, top: 1264, bottom: 1626, name: "119", youtubeLink: "LINK" },
  { page: 265, top: 1628, bottom: 1824, name: "120", youtubeLink: "LINK" },
  { page: 265, top: 1835.5, bottom: 2109.5, name: "121", youtubeLink: "LINK" },
  { page: 266, top: 202, bottom: 748, name: "122", youtubeLink: "LINK" },
  { page: 266, top: 754, bottom: 2081.5, name: "123", youtubeLink: "LINK" },
  { page: 268, top: 497, bottom: 1744, name: "124", youtubeLink: "LINK" },
  { page: 268, top: 1757.5, bottom: 2048.5, name: "125", youtubeLink: "LINK" },
  { page: 269, top: 179, bottom: 2072.5, name: "126", youtubeLink: "LINK" },
  { page: 270, top: 1056, bottom: 1211, name: "127", youtubeLink: "LINK" },
  { page: 270, top: 1227, bottom: 1757, name: "128", youtubeLink: "LINK" },
  { page: 270, top: 1746.5, bottom: 2093.5, name: "129", youtubeLink: "LINK" },
  { page: 271, top: 740, bottom: 2097.5, name: "130", youtubeLink: "LINK" },
  {
    page: 271,
    top: 1754.5,
    bottom: 2095.5,
    name: "130_trio",
    youtubeLink: "https://youtube.com/embed/QhBrO5ckIuI?start=1141&autoplay=1",
  },
  { page: 273, top: 1299, bottom: 2067.5, name: "131", youtubeLink: "LINK" },
  { page: 274, top: 196, bottom: 799, name: "132", youtubeLink: "LINK" },
  { page: 274, top: 826, bottom: 2054.5, name: "133", youtubeLink: "LINK" },
  { page: 275, top: 176, bottom: 731, name: "134", youtubeLink: "LINK" },
  { page: 275, top: 706, bottom: 1760, name: "135", youtubeLink: "LINK" },
  { page: 275, top: 1743.5, bottom: 2094.5, name: "136", youtubeLink: "LINK" },
  { page: 276, top: 727, bottom: 2062, name: "137", youtubeLink: "LINK" },
  { page: 277, top: 199, bottom: 765, name: "138", youtubeLink: "LINK" },
  { page: 277, top: 761, bottom: 2100.5, name: "139", youtubeLink: "LINK" },
  { page: 279, top: 718, bottom: 952, name: "140", youtubeLink: "LINK" },
  { page: 279, top: 953, bottom: 1414, name: "141", youtubeLink: "LINK" },
  { page: 279, top: 1437, bottom: 2078.5, name: "142", youtubeLink: "LINK" },
  { page: 280, top: 207, bottom: 2120.5, name: "143", youtubeLink: "LINK" },
  { page: 281, top: 199, bottom: 2090.5, name: "144", youtubeLink: "LINK" },
  { page: 282, top: 206, bottom: 526, name: "145", youtubeLink: "LINK" },
  { page: 282, top: 541, bottom: 2104.5, name: "146", youtubeLink: "LINK" },
  { page: 283, top: 1239.5, bottom: 2089.5, name: "147", youtubeLink: "LINK" },
];

const references = [
  {
    page: 17,
    left: 1196,
    right: 1337,
    top: 1326,
    bottom: 1369,
    name: "1",
  },
  { page: "17", left: 241, right: 390, top: 1473, bottom: 1509, name: "2" },
  {
    page: "17",
    left: 993,
    right: 1135,
    top: 1731.5,
    bottom: 1768.5,
    name: "3",
  },
  { page: 17, left: 470, right: 612, top: 1760.5, bottom: 1798.5, name: "1" },
  { page: 17, left: 497, right: 654, top: 1943.5, bottom: 1980.5, name: "75" },
  { page: "18", left: 424, right: 565, top: 427, bottom: 466, name: "4" },
  { page: "18", left: 1382, right: 1526, top: 709, bottom: 755, name: "5" },
  { page: "18", left: 767, right: 906, top: 860, bottom: 901, name: "6" },
  { page: "18", left: 757, right: 891, top: 1047, bottom: 1081, name: "7" },
  { page: "18", left: 1035, right: 1176, top: 1115, bottom: 1151, name: "8" },
  { page: "18", left: 1030, right: 1169, top: 1802, bottom: 1844, name: "3" },
  { page: "18", left: 1356, right: 1497, top: 1840, bottom: 1879, name: "1" },
  { page: "18", left: 1423, right: 1583, top: 1879, bottom: 1915, name: "55" },
  { page: "18", left: 979, right: 1120, top: 1952, bottom: 1989, name: "9" },
  { page: "19", left: 20, right: 190, top: 242, bottom: 282, name: "10" },
  { page: "19", left: 640, right: 802, top: 286, bottom: 325, name: "11" },
  { page: 19, left: 561, right: 883, top: 393, bottom: 434, name: "130_trio" },
  { page: "19", left: 619, right: 766, top: 469, bottom: 502, name: "6" },
  { page: "19", left: 1392, right: 1552, top: 513, bottom: 553, name: "12" },
  { page: "19", left: 304, right: 460, top: 571, bottom: 608, name: "90" },
  { page: "19", left: 401, right: 552, top: 613, bottom: 648, name: "75" },
  { page: "19", left: 721, right: 879, top: 649, bottom: 687, name: "13" },
  { page: "19", left: 922, right: 1081, top: 726, bottom: 762, name: "14" },
  { page: "19", left: 106, right: 261, top: 1333, bottom: 1370, name: "90" },
  { page: "20", left: 428, right: 600, top: 1432, bottom: 1464, name: "11" },
  { page: "20", left: 818, right: 988, top: 1428, bottom: 1465, name: "15" },
  { page: "20", left: 1208, right: 1369, top: 1537, bottom: 1568, name: "17" },
  { page: "20", left: 615, right: 787, top: 1792, bottom: 1832, name: "16" },
  { page: "20", left: 888, right: 1053, top: 1938, bottom: 1979, name: "18" },
  { page: "21", left: 641, right: 791, top: 275, bottom: 314, name: "1" },
  { page: "21", left: 952, right: 1102, top: 276, bottom: 316, name: "6" },
  { page: "21", left: 397, right: 562, top: 423, bottom: 457, name: "19" },
  { page: "21", left: 1020, right: 1186, top: 420, bottom: 458, name: "55" },
  { page: "21", left: 1416, right: 1584, top: 565, bottom: 599, name: "20" },
  { page: "21", left: 778, right: 943, top: 600, bottom: 635, name: "21" },
  { page: "21", left: 189, right: 349, top: 638, bottom: 674, name: "22" },
  { page: "21", left: 483, right: 645, top: 636, bottom: 673, name: "23" },
  {
    page: 21,
    left: 1222,
    right: 1352,
    top: 2076.5,
    bottom: 2107.5,
    name: "27",
  },
  { page: "22", left: 538, right: 566, top: 417, bottom: 451, name: "1" },
  { page: "22", left: 576, right: 611, top: 417, bottom: 453, name: "10" },
  { page: "22", left: 622, right: 655, top: 417, bottom: 452, name: "11" },
  { page: "22", left: 840, right: 986, top: 417, bottom: 454, name: "6" },
  { page: "22", left: 1173, right: 1317, top: 420, bottom: 454, name: "16" },
  { page: "22", left: 888, right: 1014, top: 528, bottom: 560, name: "8" },
  { page: "22", left: 82, right: 184, top: 596, bottom: 632, name: "25" },
  { page: "22", left: 742, right: 884, top: 853, bottom: 887, name: "15" },
  { page: "22", left: 989, right: 1134, top: 854, bottom: 891, name: "24" },
  { page: "22", left: 1260, right: 1404, top: 854, bottom: 891, name: "21" },
  { page: "22", left: 589, right: 747, top: 889, bottom: 924, name: "130" },
  { page: "22", left: 562, right: 693, top: 965, bottom: 997, name: "3" },
  { page: "23", left: 108, right: 250, top: 241, bottom: 278, name: "9" },
  { page: "23", left: 839, right: 983, top: 422, bottom: 460, name: "5" },
  { page: "23", left: 713, right: 877, top: 530, bottom: 566, name: "47" },
  { page: "23", left: 666, right: 826, top: 715, bottom: 750, name: "95" },
  { page: "23", left: 369, right: 407, top: 895, bottom: 931, name: "22" },
  { page: "23", left: 417, right: 455, top: 894, bottom: 931, name: "23" },
  { page: "23", left: 27, right: 150, top: 967, bottom: 1003, name: "26" },
  { page: "23", left: 102, right: 260, top: 1443, bottom: 1477, name: "21" },
  { page: "23", left: 1263, right: 1423, top: 1550, bottom: 1583, name: "16" },
  { page: "23", left: 1433, right: 1471, top: 1546, bottom: 1587, name: "90" },
  { page: "23", left: 813, right: 955, top: 1586, bottom: 1622, name: "5" },
  { page: "23", left: 433, right: 594, top: 1660, bottom: 1697, name: "19" },
  { page: "23", left: 1015, right: 1040, top: 1730, bottom: 1765, name: "1" },
  { page: "23", left: 1051, right: 1080, top: 1732, bottom: 1768, name: "4" },
  { page: "23", left: 1086, right: 1123, top: 1731, bottom: 1766, name: "11" },
  { page: "23", left: 1024, right: 1168, top: 1769, bottom: 1804, name: "3" },
  { page: "23", left: 897, right: 1062, top: 1841, bottom: 1878, name: "27" },
  { page: "24", left: 81, right: 246, top: 350, bottom: 383, name: "95" },
  { page: "24", left: 564, right: 724, top: 383, bottom: 421, name: "24" },
  { page: "24", left: 821, right: 966, top: 422, bottom: 457, name: "8" },
  { page: "24", left: 1377, right: 1537, top: 460, bottom: 494, name: "10" },
  { page: "24", left: 118, right: 269, top: 601, bottom: 634, name: "15" },
  { page: "24", left: 452, right: 608, top: 603, bottom: 638, name: "18" },
  { page: "24", left: 796, right: 955, top: 604, bottom: 636, name: "23" },
  { page: "25", left: 106, right: 225, top: 198, bottom: 239, name: "130" },
  { page: "25", left: 1181, right: 1341, top: 351, bottom: 382, name: "18" },
  { page: "25", left: 107, right: 265, top: 529, bottom: 563, name: "28" },
  { page: "25", left: 1447, right: 1600, top: 858, bottom: 892, name: "10" },
  { page: "25", left: 1297, right: 1441, top: 895, bottom: 929, name: "1" },
  { page: "25", left: 1046, right: 1210, top: 1332, bottom: 1364, name: "29" },
  { page: "25", left: 230, right: 385, top: 1550, bottom: 1586, name: "28" },
  { page: "25", left: 357, right: 516, top: 1916, bottom: 1950, name: "31" },
  { page: "26", left: 297, right: 460, top: 458, bottom: 492, name: "31" },
  { page: "26", left: 876, right: 1029, top: 569, bottom: 599, name: "32" },
  { page: "26", left: 865, right: 1025, top: 821, bottom: 850, name: "33" },
  { page: "26", left: 558, right: 713, top: 1113, bottom: 1147, name: "34" },
  { page: "26", left: 117, right: 271, top: 1552, bottom: 1586, name: "35" },
  { page: "26", left: 788, right: 946, top: 1766, bottom: 1799, name: "36" },
  { page: "26", left: 784, right: 940, top: 1879, bottom: 1915, name: "28" },
  { page: "26", left: 1306, right: 1461, top: 1841, bottom: 1872, name: "31" },
  { page: "27", left: 756, right: 924, top: 1371, bottom: 1408, name: "37" },
  { page: "27", left: 339, right: 500, top: 1591, bottom: 1626, name: "38" },
  { page: "27", left: 1333, right: 1492, top: 1666, bottom: 1697, name: "39" },
  { page: "28", left: 634, right: 796, top: 749, bottom: 785, name: "40" },
  { page: "28", left: 88, right: 247, top: 785, bottom: 820, name: "41" },
  { page: "28", left: 1168, right: 1328, top: 859, bottom: 890, name: "42" },
  { page: "28", left: 1267, right: 1429, top: 968, bottom: 1000, name: "43" },
  { page: "28", left: 751, right: 910, top: 1043, bottom: 1076, name: "44" },
  { page: "28", left: 191, right: 354, top: 1149, bottom: 1182, name: "45" },
  { page: "28", left: 43, right: 169, top: 1369, bottom: 1401, name: "46" },
  { page: "28", left: 359, right: 519, top: 1405, bottom: 1441, name: "47" },
  { page: "28", left: 851, right: 1003, top: 1404, bottom: 1439, name: "44" },
  { page: "28", left: 21, right: 128, top: 1581, bottom: 1622, name: "48" },
  { page: "28", left: 678, right: 839, top: 1917, bottom: 1945, name: "49" },
  { page: "29", left: 27, right: 148, top: 276, bottom: 312, name: "50" },
  { page: "29", left: 1316, right: 1495, top: 419, bottom: 453, name: "134" },
  { page: "29", left: 1299, right: 1463, top: 529, bottom: 561, name: "51" },
  { page: "29", left: 1291, right: 1456, top: 1038, bottom: 1072, name: "52" },
  { page: "29", left: 1068, right: 1226, top: 1473, bottom: 1509, name: "53" },
  { page: "30", left: 285, right: 454, top: 275, bottom: 311, name: "54" },
  { page: "30", left: 44, right: 196, top: 420, bottom: 455, name: "41" },
  { page: "30", left: 868, right: 1035, top: 640, bottom: 676, name: "54" },
  { page: "30", left: 83, right: 252, top: 708, bottom: 743, name: "55" },
  { page: "30", left: 1302, right: 1450, top: 753, bottom: 788, name: "56" },
  { page: "30", left: 1416, right: 1578, top: 862, bottom: 895, name: "57" },
  { page: "30", left: 1192, right: 1231, top: 1147, bottom: 1184, name: "54" },
  { page: "30", left: 1242, right: 1282, top: 1148, bottom: 1185, name: "56" },
  { page: "30", left: 1289, right: 1331, top: 1147, bottom: 1185, name: "58" },
  { page: "30", left: 1324, right: 1472, top: 1185, bottom: 1221, name: "56" },
  { page: "30", left: 987, right: 1155, top: 1220, bottom: 1255, name: "55" },
  { page: "30", left: 515, right: 675, top: 1288, bottom: 1325, name: "58" },
  { page: "30", left: 525, right: 680, top: 1651, bottom: 1683, name: "59" },
  { page: "30", left: 994, right: 1160, top: 1724, bottom: 1761, name: "60" },
  { page: "30", left: 714, right: 870, top: 1833, bottom: 1864, name: "61" },
  { page: "30", left: 108, right: 258, top: 1865, bottom: 1899, name: "62" },
  { page: "30", left: 1196, right: 1307, top: 2065, bottom: 2102, name: "19" },
  { page: "31", left: 1370, right: 1521, top: 237, bottom: 273, name: "57" },
  { page: "31", left: 1319, right: 1485, top: 308, bottom: 345, name: "63" },
  { page: "31", left: 106, right: 265, top: 379, bottom: 413, name: "64" },
  { page: "31", left: 105, right: 264, top: 562, bottom: 595, name: "65" },
  { page: "31", left: 470, right: 619, top: 636, bottom: 670, name: "65" },
  { page: "31", left: 376, right: 535, top: 780, bottom: 813, name: "66" },
  { page: "31", left: 1372, right: 1531, top: 1431, bottom: 1463, name: "67" },
  { page: "31", left: 1321, right: 1490, top: 1608, bottom: 1642, name: "67" },
  { page: "32", left: 237, right: 392, top: 275, bottom: 307, name: "67" },
  { page: "32", left: 1422, right: 1592, top: 413, bottom: 449, name: "68" },
  { page: "32", left: 302, right: 445, top: 962, bottom: 994, name: "69" },
  { page: "32", left: 435, right: 599, top: 1359, bottom: 1394, name: "70" },
  { page: "32", left: 779, right: 939, top: 1757, bottom: 1791, name: "72" },
  { page: "33", left: 131, right: 293, top: 1432, bottom: 1469, name: "73" },
  { page: "33", left: 448, right: 613, top: 1436, bottom: 1470, name: "74" },
  { page: "33", left: 1298, right: 1482, top: 1433, bottom: 1468, name: "75" },
  { page: "33", left: 675, right: 844, top: 1471, bottom: 1504, name: "76" },
  { page: "34", left: 1306, right: 1472, top: 268, bottom: 303, name: "22" },
  { page: "34", left: 966, right: 1123, top: 347, bottom: 377, name: "77" },
  { page: "34", left: 1027, right: 1192, top: 632, bottom: 664, name: "20" },
  { page: "34", left: 539, right: 708, top: 964, bottom: 996, name: "78" },
];

const joinedReferences = references.map((reference) => {
  return {
    ...reference,
    example: examples.filter(({ name }) => name === reference.name)[0],
  };
});

export default {
  joinedReferences,
  layout: "SEPARATE",
  title: "Т. Кюрегян. Форма в музыке XVII-XX веков",
  chapters: [{ title: "Тема 1. Предложение и период", from: 16, to: 38 }],
  images: importAll(require.context(`../../pages/kuregyan`, false, /\.png$/)),
};
